import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="file-input"


export default class extends Controller {
  static targets = ["input", "label"]
  static values = { emptyText: String }

  update() {
    const files = Array.from(this.inputTarget.files || [])

    this.labelTarget.textContent = files.length
      ? files.map(file => file.name).join(", ")
      : this.emptyTextValue

  }


  disconnect() {
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = this.emptyTextValue
    }

    if (this.hasInputTarget) {
      this.inputTarget.value = null
    }
  }
}